<form [formGroup]="form">
  <p-accordion [value]="activeGroupIndex">
    @for (group of groupsControls(); track group; let index = $index) {
      <p-accordion-panel [value]="index">
        <p-accordion-header>
          <div class="me-4 flex flex-1 items-center justify-between gap-4">
            <div class="text-sm text-gray-500">
              <span class="font-bold">#{{ index + 1 }}</span>
              <span class="ms-2">
                {{ cosmeticsFor(group).length }} kosmetyków
              </span>
            </div>

            @if (allowChangeGroups()) {
              <p-button
                (onClick)="handleRemoveGroupClick(index)"
                appPrimengButton
                label="Usuń grupę"
                severity="danger" />
            }
          </div>
        </p-accordion-header>

        <p-accordion-content>
          <div
            class="mb-4 grid gap-4 lg:grid-cols-[minmax(0,1fr)_24rem] lg:items-start">
            <app-form-control label="Opis grupy zawartości">
              <app-summernote
                [formControl]="group.controls.description"
                [uploadFn]="uploadFn()" />
            </app-form-control>

            <div>
              <app-form-control label="Widoczne w ankiecie">
                @if (allowChangeGroups()) {
                  <p-toggle-switch
                    [formControl]="group.controls.isVisibleInQuestionnaire" />
                } @else {
                  <div pTooltip="Zablokowane do edycji" tooltipPosition="left">
                    <p-toggle-switch
                      [disabled]="true"
                      [formControl]="group.controls.isVisibleInQuestionnaire" />
                  </div>
                }
              </app-form-control>

              <app-form-control label="Strategia losowania">
                <p-select
                  [fluid]="true"
                  [showClear]="false"
                  [formControl]="group.controls.missingItemPickStrategy"
                  [options]="valueOrDefault(strategySelectItems$ | async, [])"
                  appPrimengSelect
                  placeholder="Wybierz strategię" />
              </app-form-control>
            </div>
          </div>

          @if (allowChangeCosmetics()) {
            <div class="mb-4 flex justify-end">
              <p-button
                (onClick)="handleSelectCosmeticsClick(index)"
                appPrimengButton
                label="Dodaj kosmetyki"
                size="small" />
            </div>
          }

          @if (isNotEmptyArray(cosmeticsFor(group))) {
            <app-admin-box-sale-group-cosmetics-table
              [allowChangeCosmetics]="allowChangeCosmetics()"
              [items]="cosmeticsFor(group)"
              (editClickEvent)="handleEditCosmeticClick(index, $event)"
              (removeClickEvent)="handleRemoveCosmeticClick(index, $event)" />
          } @else {
            <div
              class="rounded-sm border border-dashed border-gray-300 p-4 text-sm text-gray-500 italic">
              Brak kosmetyków w grupie. Dodaj co najmniej jeden kosmetyk.
            </div>
          }
        </p-accordion-content>
      </p-accordion-panel>
    } @empty {
      <div class="rounded-sm border border-gray-200 p-4">
        <div class="mb-2 italic">Brak skonfigurowanych grup zawartości.</div>

        @if (allowChangeGroups()) {
          <p-button
            (onClick)="handleAddClick()"
            [fluid]="true"
            appPrimengButton
            label="Dodaj grupę zawartości"
            size="small" />
        }
      </div>
    }

    @if (allowChangeGroups() && isNotEmptyArray(groupsControls())) {
      <div class="mt-3 flex flex-col">
        <p-button
          (onClick)="handleAddClick()"
          [fluid]="true"
          appPrimengButton
          label="Dodaj grupę zawartości"
          size="small" />
      </div>
    }
  </p-accordion>
</form>

@if (cosmeticModalVisible()) {
  <app-admin-box-sale-cosmetic-select-modal
    [excludedIds]="excludedIdsForEditingGroup()"
    [visible]="cosmeticModalVisible()"
    (cancelEvent)="handleCosmeticModalCancelEvent()"
    (submitEvent)="handleCosmeticModalSubmitEvent($event)" />
}

@if (editingCosmetic(); as editingCosmetic) {
  <app-admin-box-sale-cosmetic-available-quantity-modal
    [amount]="editingCosmetic.amount"
    [availableQuantity]="editingCosmetic.availableQuantity"
    [cosmeticName]="editingCosmetic.name"
    [visible]="availableQuantityModalVisible()"
    (cancelEvent)="handleAvailableQuantityModalCancelEvent()"
    (submitEvent)="handleAvailableQuantityModalSubmitEvent($event)" />
}
